const _excluded = ["title", "hidden", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import { Collapse } from '@material-ui/core';
import { Typography } from 'seagull';
import { WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import styles from "./ServicesSection.module.scss";
export default function BillingControlSection(props) {
  const {
    title,
    hidden,
    children
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const [shown, setShown] = useState(true);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    hidden: hidden
  }), /*#__PURE__*/React.createElement("button", {
    className: styles.recurrencePeriod,
    onClick: () => setShown(!shown)
  }, /*#__PURE__*/React.createElement(Typography, {
    as: "span"
  }, title), shown ? /*#__PURE__*/React.createElement(WideArrowUpward, null) : /*#__PURE__*/React.createElement(WideArrowDownward, null)), /*#__PURE__*/React.createElement(Collapse, {
    in: shown
  }, /*#__PURE__*/React.createElement("ul", null, children)));
}